/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import styles from '../index.module.scss';
import { PodcastListInterface, Podcastfeature } from '../store';
import { Button } from '@ui-elements';
import classnames from 'classnames';
import { toCssColor } from '~/common/utils';

interface PodcastBlockProps {
  podcastBlock?: PodcastListInterface[];
  podcastFeatures?: Podcastfeature[];
}

const PodcastSeries: React.FC<PodcastBlockProps> = ({
  podcastBlock,
  podcastFeatures,
}) => {
  const [contents, setContents] = useState<PodcastListInterface[]>([]);
  const [isLargeThumbnail, setIsLargeThumbnail] = useState(false);

  useEffect(() => {
    const podcastListContents: PodcastListInterface[] = (
      podcastBlock ?? []
    ).map((podcast) => ({
      ...podcast,
      ctaContent: (podcast.ctaContent ?? []).map((cta) => ({ ...cta })),
    }));
    setContents(podcastListContents);
    const firstPodcastFeature = podcastFeatures?.[0] || {};
    setIsLargeThumbnail(
      firstPodcastFeature.thumbnailSize?.toLowerCase() === 'large'
    );
  }, [podcastFeatures, podcastBlock]);

  const PodcastList: React.FC<{ content: PodcastListInterface }> = ({
    content: {
      showTag,
      tagColor,
      tagFontColor,
      tagName,
      title,
      titleFontColor,
      text,
      contentFontColor,
      ctaContent,
      ctaAlignment,
      thumbnail,
      contentGap,
    },
  }) => {
    const [firstCtaContent] = ctaContent || [];
    return (
      <div
        className={classnames(styles.podcast, {
          [styles.isLarge]: isLargeThumbnail,
        })}
      >
        {showTag === 'True' && (
          <div
            className={styles.podcastBanner}
            style={{
              backgroundColor: toCssColor(tagColor, '#EFEFEF'),
              color: toCssColor(tagFontColor, '#646566'),
            }}
          >
            {tagName}
          </div>
        )}
        {/* MOBILE VIEW - START */}
        <div
          className={classnames(styles.imageContainer, {
            [styles.isLarge]: isLargeThumbnail,
          })}
        >
          <div
            className={classnames(styles.imageHolder, {
              [styles.isLarge]: isLargeThumbnail,
            })}
          >
            <img src={thumbnail} loading="lazy" />
          </div>
        </div>
        <div
          className={classnames(
            styles.contentTitle,
            {
              [styles.isLarge]: isLargeThumbnail,
            },
            styles.mobile
          )}
          style={{
            color: toCssColor(titleFontColor, '#323334'),
          }}
          dangerouslySetInnerHTML={{ __html: title || '' }}
        />
        <div
          className={classnames(
            styles.contentBody,
            {
              [styles.isLarge]: isLargeThumbnail,
            },
            styles.mobile
          )}
          style={{
            color: toCssColor(contentFontColor, '#323334'),
          }}
          dangerouslySetInnerHTML={{ __html: text || '' }}
        />
        <div
          className={classnames(
            styles.learnMore,
            {
              [styles.isLarge]: isLargeThumbnail,
            },
            styles.mobile
          )}
          style={{
            textAlign: ctaAlignment ? ctaAlignment : 'left',
          }}
        >
          {firstCtaContent ? (
            <Button
              href={firstCtaContent.url}
              target={firstCtaContent.target || '_self'}
              className={styles.learnMoreBtn}
              buttonSize="small"
            >
              {firstCtaContent.textDisplay}
            </Button>
          ) : (
            <></>
          )}
        </div>
        {/* MOBILE VIEW - END */}
        <div
          className={classnames(styles.paddingContainer, {
            [styles.isLarge]: isLargeThumbnail,
          })}
          style={{
            ...(contentGap && { padding: contentGap }),
          }}
        >
          <div
            className={classnames(styles.contentTitle, {
              [styles.isLarge]: isLargeThumbnail,
            })}
            style={{
              color: toCssColor(titleFontColor, '#323334'),
            }}
            dangerouslySetInnerHTML={{ __html: title || '' }}
          />
          <div
            className={classnames(styles.contentBody, {
              [styles.isLarge]: isLargeThumbnail,
            })}
            style={{
              color: toCssColor(contentFontColor, '#323334'),
            }}
            dangerouslySetInnerHTML={{ __html: text || '' }}
          />
          <div
            className={classnames(styles.learnMore, {
              [styles.isLarge]: isLargeThumbnail,
            })}
            style={{
              textAlign: ctaAlignment ? ctaAlignment : 'left',
            }}
          >
            {firstCtaContent ? (
              <Button
                href={firstCtaContent.url}
                target={firstCtaContent.target || '_self'}
                className={styles.learnMoreBtn}
                buttonSize="small"
              >
                {firstCtaContent.textDisplay}
              </Button>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    );
  };

  const { contentPadding, seriesHeader } = podcastFeatures?.[0] || {};

  return (
    <div
      id="podcast-series"
      className={classnames(styles.isSeries, styles.podcast_container)}
      style={{ ...(contentPadding && { padding: contentPadding }) }}
    >
      <div className={styles.podcast_contents}>
        {seriesHeader && (
          <div
            className={classnames(styles.seriesHeader, styles.mobile)}
            dangerouslySetInnerHTML={{ __html: seriesHeader || '' }}
          />
        )}
        <div className={styles.podcasts}>
          {contents.map((content, index) => (
            <PodcastList key={index} content={content} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PodcastSeries;
